<template lang='pug'>
    v-carousel-item.fill-height
      v-img(  :src='item.imagenes[0]' cover height='100%' style='position: relative').fill-height
        v-container
          v-row( justify='start' align='start' ).py-10         
            p.text-uppercase.display-1.font-weight-bold.mx-12.white--text.icono-international.icono-grande( v-html='Proyectos.titulo').pt-7.pl-7.mt-10
          v-row.justify-center.align-end.fill-height(  style='position: absolute; bottom: 0; left: 0; rigth: 0; width: 100% ').mx-auto
            v-col.align-center.pb-10.justify-center( style='background: linear-gradient(180deg, rgba(0,0,0,0.0) 10%,  rgba(0,0,0,1  ) 100%); height: 400px').pb-10
              v-row.align-end.fill-height

                v-col
                  p.display-1.text-center.white--text 
                    strong {{item.titulo}} 
                  p.title.white--text.font-weight-thin.text-center {{item.subtitulo}}  
                  v-row.justify-center.mb-10
                    v-btn.rojo(tile small  :to='{name: "novedades", params: {articulo: item.titulo }}') Conoce más de él, aquí 

     
</template>
<script>
export default {
  data: ()=>({
    dialog: false
  }),
  props: {
    item:Object
  },
  computed:{
    Proyectos() {
      return this.$contenido.Proyectos || {}
    },
  }
}
</script>